import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import getLocale from '../../i18n/getLocale';


class ScheduleGradeBaseEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      schedule_grade_bases: {},
      schedule_grade: {},
      schedule: {},
      staffs_list: [],
      bases_list: [],
      designations_list: [],
      date_start: null,
      date_finish: null,
      base_id: null,
      designation_id: null,
      staff_id: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);

  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

    handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var aircraft_model_id = 0;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/base/registros/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas/base');
        if (responseJson.status === 'success') {
          self.setState({schedule_grade_bases: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/escala/grade/info/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({schedule_grade: responseJson.data.schedule_grade});
          self.setState({schedule: responseJson.data.schedule_grade.schedule});
          self.setState({date_start: responseJson.data.schedule_grade.schedule.date_start_str});
          self.setState({date_finish: responseJson.data.schedule_grade.schedule.date_finish_str});
        }
      }).then(() => {
      var url = config.get('api') + '/tripulantes/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staffs_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/bases/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({bases_list: responseJson.data});
        }
      var url = config.get('api') + '/escala/base/designacoes';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({designations_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     });  /* Overlay */ });  }); }); });
    });
  }

  add(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      schedule_grade_id: this.props.match.params.id,
      designation_id: this.state.designation_id,
      staff_id: this.state.staff_id,
      base_id: this.state.base_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/base', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete(id) {
    var datasave = {
      id: id,
    };
    if (window.confirm(this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.deletar)) {
      var self = this;
      this.setState({overlay: {message: '', type: '', status: 'open'}});
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/base/registro', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.titulo} -  {this.state.schedule.name}</h3>
      <Link to={"/escala/base/editar/" + this.state.schedule.id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.formulario.Funcionario}:</label>
              <Select
                className=""
                name="staff_id"
                value={this.state.staff_id}
                searchable={true}
                placeholder={this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.formulario.placeholder.SelecionarFuncionario}
                onChange={this.handleSelectChange.bind(this, 'staff_id')}
                options={this.state.staffs_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.formulario.Designacao}:</label>
              <Select
                className=""
                name="designation_id"
                value={this.state.designation_id}
                searchable={true}
                placeholder={this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'designation_id')}
                options={this.state.designations_list}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.formulario.Base}:</label>
              <Select
                className=""
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases_list}
                required
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.adicionar}</button>
        </div>
      </form>
      <hr/>
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.tabela.Tripulante}</th>
            <th className="text-center">{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.tabela.Designacao}</th>
            <th className="text-center">{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.tabela.Base}</th>
            <th className="text-center">{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.tabela.DataInicial}</th>
            <th className="text-center">{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.tabela.DataFinal}</th>
            <th className="col-md-1 text-center">{this.locale.GradesDeEscala.EditarBaseDaGradeDeEscala.tabela.Acoes}</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.schedule_grade_bases).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.schedule_grade_bases[k].staff.name}</td>
                <td className="text-center">{self.state.schedule_grade_bases[k].designation.name}</td>
                <td className="text-center">{self.state.schedule_grade_bases[k].base.name}</td>
                <td className="text-center">{self.state.schedule_grade_bases[k].date_start_str}</td>
                <td className="text-center">{self.state.schedule_grade_bases[k].date_finish_str}</td>
                <td className="text-center"><button className="btn btn-sm btn-danger" onClick={() => { self.delete( self.state.schedule_grade_bases[k].id); }}><i className="fa fa-fw fa-trash"></i></button></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default ScheduleGradeBaseEdit;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/ScheduleGradeBaseEdit.js